function fullCalendarObject(aSchedule, aMomentStringDate, aIsAllDay, aIsRecurring, aIsEditable) {
    this.scheduleId = aSchedule.Id;
    this.title = aSchedule.Name;
    this.allDay = aIsAllDay;
    this.isRecurring = aIsRecurring;
    this.backgroundColor = getScheduleColor(aSchedule);

    if (displayDSTSchedules()) {
        this.start = moment(aMomentStringDate + ' ' + getTimeFormatter(aSchedule.StartTimeLocal));
        this.end = moment(aMomentStringDate + ' ' + getTimeFormatter(aSchedule.EndTimeLocal));
    } else {
        this.start = moment(aMomentStringDate + ' ' + displayShortTime(aSchedule.StartTime));
        this.end = moment(aMomentStringDate + ' ' + displayShortTime(aSchedule.EndTime));
    }

    this.editable = aIsEditable;
    this.state = 1;
    this.textColor = 'white';
}
if (typeof exports !== 'undefined') {
    module.exports = fullCalendarObject;
}